import PackageRequestMain from "../../../../features/customer/package-request/components/package-request-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";

const title = "Package Request";

const PackageRequestPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <PackageRequestMain />;
};

export default PackageRequestPage;
